import React from "react";
import "../style/study.css";

const DEGREE = {
    title: "Bachelor of Information Technology Engineering",
    school: "Royal University of Phnom Penh (RUPP)",
    period: "Graduated July 2025",
    logos: [
        { src: "/image/rupp.png", alt: "RUPP logo" },
        { src: "/image/fe.png", alt: "Faculty of Engineering logo" },
    ],
};

const PROJECT_YEARS = [
    {
        year: "Year 2",
        images: ["/image/1.png", "/image/2.png", "/image/3.png"],
    },
    {
        year: "Year 3",
        images: [
            "/image/1 copy.png",
            "/image/2 copy.png",
            "/image/3 copy.png",
            "/image/4 copy.png",
        ],
    },
];

const THESIS_LINK =
    "https://drive.google.com/file/d/1FsgM_WDJ22F7BEkm_d7DiY72uW-nMA_r/view?usp=sharing";

const Study = () => {
    return (
        <section className="study content-width" id="study">
            <div className="study-header">
                <p className="study-eyebrow">Education</p>
                <h1>Academic Background</h1>
            </div>

            {/* ---------- Degree card ---------- */}
            <div className="degree-card">
                <div className="degree-logos">
                    {DEGREE.logos.map((logo) => (
                        <img key={logo.src} src={logo.src} alt={logo.alt} />
                    ))}
                </div>
                <div className="degree-info">
                    <span className="degree-period">{DEGREE.period}</span>
                    <h2>{DEGREE.title}</h2>
                    <p>{DEGREE.school}</p>
                </div>
            </div>

            {/* ---------- Project timeline ---------- */}
            <div className="project-ui">
                <h2 className="section-heading">Capstone &amp; Coursework Projects</h2>

                <div className="project-timeline">
                    {PROJECT_YEARS.map((entry, idx) => (
                        <div className="timeline-row" key={entry.year}>
                            <div className="timeline-marker">
                                <span className="timeline-dot">{idx + 1}</span>
                                {idx !== PROJECT_YEARS.length - 1 && (
                                    <span className="timeline-line" />
                                )}
                            </div>
                            <div className="timeline-content">
                                <h3>{entry.year}</h3>
                                <div className="project-gallery">
                                    {entry.images.map((src) => (
                                        <div className="project-thumb" key={src}>
                                            <img src={src} alt={`${entry.year} project screenshot`} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Final year — thesis link */}
                    <div className="timeline-row">
                        <div className="timeline-marker">
                            <span className="timeline-dot">{PROJECT_YEARS.length + 1}</span>
                        </div>
                        <div className="timeline-content">
                            <h3>Year 4</h3>
                            <a
                                className="thesis-link"
                                href={THESIS_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View final year project
                                <span aria-hidden="true">→</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Study;